import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-text',
    templateUrl: './block-text.component.html',
})

export class BlockTextComponent extends BlockAbstractComponent implements OnInit {

}
